import { render } from "./inventoryEstimated.vue?vue&type=template&id=b985aae8&scoped=true"
import script from "./inventoryEstimated.vue?vue&type=script&lang=js"
export * from "./inventoryEstimated.vue?vue&type=script&lang=js"

import "./inventoryEstimated.vue?vue&type=style&index=0&id=b985aae8&scoped=true&lang=scss"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b985aae8"]])

export default __exports__